import { h } from 'preact';
import { Text } from 'preact-i18n';
import util from 'preact-util';

// Read-only config. NEVER mutate these descriptors in place — pickers read them
// and produce copies; buildBodyWithRelated returns a new string.
export const SUPPORT_TICKET_ENTITIES = [
    {
        type: 'sale',
        label: <Text id='support.entity.sale'>Sale</Text>,
        icon: 'fa-duotone fa-receipt',
        endpoint: '/api/sales/',
        query: { limit: 8, sort: '-saleDate' },
        renderRow: e => (
            <div>
                <strong>#{e.saleNumber}</strong>
                {e.saleDate ? <span class='text-body-secondary ms-2'>{util.isoDate(e.saleDate, false, false, true)}</span> : null}
            </div>
        ),
        formatSummary: e => `Salg #${e.saleNumber}`,
    },
    {
        type: 'animal',
        label: <Text id='support.entity.animal'>Animal</Text>,
        icon: 'fa-duotone fa-paw',
        endpoint: '/api/animals/',
        query: { limit: 8 },
        renderRow: e => (
            <div>
                <strong>{e.name}</strong>
                {(e.breed || e.species) ? <span class='text-body-secondary ms-2'>{e.breed || e.species}</span> : null}
                {e.chipId ? <span class='text-body-secondary ms-2'>#{e.chipId}</span> : null}
            </div>
        ),
        formatSummary: e => `Dyr: ${e.name}${e.species ? ` (${e.species})` : ''} #${e.id}`,
    },
    {
        type: 'journal',
        label: <Text id='support.entity.journal'>Journal</Text>,
        icon: 'fa-duotone fa-notes-medical',
        endpoint: '/api/journals/',
        query: { limit: 8, sort: '-date -createdDate' },
        renderRow: e => (
            <div>
                <strong>Journal #{e.id}</strong>
                {e.date ? <span class='text-body-secondary ms-2'>{util.isoDate(e.date, false, false, true)}</span> : null}
            </div>
        ),
        formatSummary: e => `Journal #${e.id}`,
    },
    {
        type: 'visitor',
        label: <Text id='support.entity.visitor'>Customer</Text>,
        icon: 'fa-duotone fa-user',
        endpoint: '/api/visitors/',
        // The visitors endpoint sorts by lastname (not relevance) and text search
        // matches substrings across many fields, so a low limit cuts off the person
        // actually searched for (TICKET-01297: "Per Sve" — Sveahaugen sorted #16).
        // The result dropdown scrolls, so a higher limit is safe.
        query: { limit: 25 },
        renderRow: e => (
            <div>
                <strong>{`${e.firstname || ''} ${e.lastname || ''}`.trim()}</strong>
                {e.cellphone ? <span class='text-body-secondary ms-2'>{e.cellphone}</span> : null}
            </div>
        ),
        formatSummary: e => `Kunde: ${`${e.firstname || ''} ${e.lastname || ''}`.trim()} #${e.id}`,
    },
    {
        type: 'calendar',
        label: <Text id='support.entity.calendar'>Appointment</Text>,
        icon: 'fa-duotone fa-calendar',
        endpoint: '/api/calendarevents/',
        query: { limit: 8 },
        renderRow: e => (
            <div>
                <strong>{e.title || `#${e.id}`}</strong>
                {e.start ? <span class='text-body-secondary ms-2'>{util.isoDate(e.start)}</span> : null}
            </div>
        ),
        formatSummary: e => `Avtale: ${e.title || `#${e.id}`}${e.start ? ` (${util.isoDate(e.start)})` : ''} #${e.id}`,
    },
    {
        type: 'sms',
        label: <Text id='support.entity.sms'>SMS</Text>,
        icon: 'fa-duotone fa-comment-sms',
        endpoint: '/api/sms/',
        query: { limit: 8, sort: '-createdDate' },
        renderRow: e => (
            <div>
                <strong>{e.cellphone || `#${e.id}`}</strong>
                {e.createdDate ? <span class='text-body-secondary ms-2'>{util.isoDate(e.createdDate)}</span> : null}
            </div>
        ),
        formatSummary: e => `SMS til ${e.cellphone || '?'} #${e.id}`,
    },
];

export function getEntityDescriptor(type) {
    return SUPPORT_TICKET_ENTITIES.find(d => d.type === type) || null;
}

// Pure: returns a NEW string. `draftRelated` is a map of type -> array of picked records.
export function buildBodyWithRelated(body, draftRelated = {}) {
    const lines = [];
    SUPPORT_TICKET_ENTITIES.forEach((descriptor) => {
        const records = (draftRelated && draftRelated[descriptor.type]) || [];
        records.forEach((record) => {
            lines.push(descriptor.formatSummary(record));
        });
    });
    if (lines.length === 0) return body;
    return `${body}\n\n---\nRelatert info:\n${lines.join('\n')}`;
}
